// extracted by mini-css-extract-plugin
export default {"header":"HeaderModal_header__spAEj","title":"HeaderModal_title__n0S2n","icon":"HeaderModal_icon__0Y-vW"};